import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import chunk from "lodash/chunk"
import styled from "styled-components"

import PostCard from "../components/Elements/PostCard"
import StDisclaimer from "../components/Common/StDisclaimer"
import { categoryClasses } from "../utils/category-classes"
import SEO from "@ifp/gatsby-theme-shared/src/components/SEO/seo"

const PostsRow = styled.div`
    @media (min-width: 450px) {
        display: flex;
        flex-wrap: wrap;
        & > div {
            margin-bottom: 48px;
        }
    }
    @media (min-width: 450px) and (max-width: 767px) {
        & > div {
            width: calc((100% - 24px) / 2);
            &:nth-child(odd) {
                margin-right: 24px;
            }
        }
    }
    @media screen and (min-width: 768px) and (max-width: 1023px) {
        & > div {
            width: calc((100% - 72px) / 4);
            &:not(:last-child) {
                margin-right: 24px;
            }
        }
    }
    @media screen and (min-width: 1024px) {
        & > div {
            width: calc((100% - 126px) / 4);
            margin-bottom: 72px;
            &:not(:last-child) {
                margin-right: 42px;
            }
        }
    }
    @supports (grid-gap: 0) {
        display: -ms-grid;
        display: grid;
        -ms-grid-columns: 1fr;
        grid-template-columns: repeat(1, 1fr);
        grid-gap: 0;
        margin-bottom: 48px;
        & > div {
            width: 100%;
            margin-right: 0;
        }
        @media screen and (min-width: 450px) {
            -ms-grid-columns: 1fr 24px 1fr;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 24px;
        }
        @media screen and (min-width: 768px) {
            -ms-grid-columns: 1fr 24px 1fr 24px 1fr 24px 1fr;
            grid-template-columns: repeat(4, 1fr);
            grid-gap: 24px;
        }
        @media screen and (min-width: 1024px) {
            margin-bottom: 70px;
            grid-gap: 42px;
        }
    }
`

export default ({ data, pageContext }) => {
    const {slug}= pageContext;
    const posts = data.allWordpressPost.edges.filter(item=>item.node.categories[0].slug === slug);
    const categoryName =
        "Uncategorized" && posts[0] && posts[0].node.categories[0].name
    const categorySlug =
        "uncategorized" && posts[0] && posts[0].node.categories[0].slug
    const [postsToShow, setPostsToShow] = useState(12)
    const showStDisclaimer = (categoryName === 'Short-term Insurance');
    useEffect(() => {
        window._waEvents.push("pageView", {
            page: {
                section: categoryName,
                name: categorySlug,
                language: "english",
            },
            sysEnv: {
                siteGroup: "rc",
            },
        })
    })

    return (
        <>
            <SEO
                title={`${categoryName} | eHealth Resource Center`}
                excerpt={`An archive of every ${categoryName} post we have published`}
                metaDescription={`An archive of every ${categoryName} post we have published`}
                slug={categorySlug}
                pageType="resources"
            />
            <div className="ehi-header--spacer"></div>
            <section className={`${categoryClasses[categorySlug]}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-lg-9 text-center">
                            <h2
                                className="h4"
                                style={{
                                    opacity: 0,
                                    animation:
                                        "fadeDownSubtle 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                                }}
                            >
                                Articles
                            </h2>
                            <h1
                                className="display-3"
                                style={{
                                    opacity: 0,
                                    animation:
                                        "scaleDown 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                                }}
                            >
                                {categoryName}
                            </h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className="PostsGallery bg-white pb-xxl">
                <div className="container container--grid">
                    <div className="container__row">
                        {chunk(posts.slice(0, postsToShow), 4).map(
                            (chunk, i) => (
                                <PostsRow key={`chunk-${i}`}>
                                    {chunk.map(({ node: post }) => (
                                        <PostCard
                                            key={post.wordpress_id}
                                            post={post}
                                            isPost
                                        />
                                    ))}
                                </PostsRow>
                            )
                        )}
                    </div>
                </div>
                {postsToShow < posts.length && (
                    <div className="text-center">
                        <button
                            className="button-tertiary"
                            onClick={() => {
                                setPostsToShow(postsToShow + 12)
                            }}
                        >
                            Load More
                        </button>
                    </div>
                )}
            </section>
            {showStDisclaimer && <section className="PostsGallery py-0" data-qa="st-disclaimer"><StDisclaimer /></section>}
            
        </>
    )
};
{/* GraphQL filter is NOT working on Server for some unknow reason, so do a filter on the page action for instead */}
export const query = graphql`
    query getCategoryPost{
        allWordpressPost{
            edges {
                node {
                    title
                    slug
                    excerpt
                    wordpress_id
                    categories {
                        name
                        slug
                    }
                    featured_media {
                        localFile {
                            childImageSharp {
                                sizes(maxWidth: 400) {
                                    ...GatsbyImageSharpSizes
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
